import { View } from "react-native";

import { Text } from "components/text_v2";
import { Spacer } from "components/spacer";
import { useMediaQuery } from "lib/media_query";

interface OffsiteSpaceDetailsSectionProps {
  title: string;
  children: JSX.Element;
}

export function OffsiteSpaceDetailsSection({
  title,
  children,
}: OffsiteSpaceDetailsSectionProps) {
  const mq = useMediaQuery();

  return (
    <View>
      <Text size="md" weight="semibold">
        {title}
      </Text>
      <Spacer size={mq.deviceQuery.mobile ? 16 : 24} />
      {children}
    </View>
  );
}
